import {
  downloadAsDraco,
  downloadAsJSON,
  ExportTarget,
} from "../../helpers/drcExporter";
import {
  resetDebugArr,
  resetSphereArr,
  setDebugSpheres,
  setDebugSqaures,
} from "./CEPH";
import { totalTime } from "./teethControls/TeethPositionHelper";
import { exportToApollo, exportToETP } from "./3dToETP";

const { addEventListener } = require("@/helpers/clickManager");

export class IdleManager {
  isIdle = true;
  idleTimeout;
  idleTimeLimit = 650;
  constructor() {
    if (IdleManager.instance) {
      return IdleManager.instance; // Return the existing instance
    }

    IdleManager.instance = this; // Store the instance

    addEventListener(
      null,
      "mousedown",
      () => {
        clearTimeout(this.idleTimeout);
        this.setIdleState(false);
      },
      0,
    );
    addEventListener(null, "mouseup", () => {
      this.resetIdleTimer();
    });
    addEventListener(null, "keydown", async key => {
      if (key.key === "q") {
        resetDebugArr();
      }
      if (key.key === "z") {
        resetSphereArr();
      }
      if (key.key === "a") {
        setDebugSqaures();
      }
      if (key.key === "x") {
        setDebugSpheres();
      }
      if (key.key === "l") {
        console.log(totalTime);
      }
      if (key.key === "e") {
        await exportToApollo();
      }
      if (key.key === "E") {
        await exportToETP();
      }

      clearTimeout(this.idleTimeout);
      this.setIdleState(false);
    });
    addEventListener(null, "keyup", () => {
      this.resetIdleTimer();
    });
  }

  setIdleState(state) {
    this.isIdle = state;
  }

  getIdleState() {
    return this.isIdle;
  }

  // Reset the idle timer
  resetIdleTimer() {
    // Clear the existing timeout and set a new one
    clearTimeout(this.idleTimeout);
    this.idleTimeout = setTimeout(
      this.setIdleState.bind(this),
      this.idleTimeLimit,
      true,
    );
  }
}
